import { render, staticRenderFns } from "./ConfirmUpdateDialog.vue?vue&type=template&id=2607e53d"
import script from "./ConfirmUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports